<template>
    <a-modal v-model="visible" title="兑换订单核销" :width="400" centered :confirmLoading="loading" @ok="doValidate()">
        <a-form-model ref="formRef" :model="formData">
            <a-form-model-item label="订单号" prop="sn" :rules="{ required: true, message: '请输入订单号' }">
                <a-input v-model="formData.sn" placeholder="请输入订单号" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import utils from '@/common/utils';

export default {
    data() {
        return {
            visible: false,
            loading: false,
            formData: {
                sn: ''
            }
        }
    },
    methods: {
        show() {
            this.formData.sn = '';
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.$refs.formRef.resetFields();
            })
        },
        doValidate() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.loading = true;
                this.http.post('/platform/goods-order/verify', this.formData).then(res => {
                    utils.showMsg('核销成功').then(() => {
                        this.$emit('success')
                    });
                }).finally(() => {
                    this.loading = false;
                })
            })
        }
    }
}
</script>

<style></style>